import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import cloneDeep from 'lodash.clonedeep'
import LoadingPage from '../../components/LoadingPage'
import { db, firestore } from '../../../config/Fire'
import * as Constants from '../../../constants'
import { getUser } from '../../../reducers'
import ListWorks from './ListWorks'
import DetailsWork from './DetailsWork'
import NewWork from './NewWork'
import { Image } from 'antd'
import './styles.css'

const workPages = {
    LIST_WORKS: 'LIST_WORKS',
    NEW_WORK: 'NEW_WORK',
    DETAILS_WORK: 'DETAILS_WORK'
}

const WorksEmployee = props => {
    const { companyType = 'Arcasa' } = props
    const [works, setWorks] = useState(null)
    const [clients, setClients] = useState(null)
    const [employees, setEmployees] = useState(null)
    const [bids, setBids] = useState(null)
    const [workOrderIdToEdit, setWorkOrderIdToEdit] = useState(null)
    const [workPage, setWorkPage] = useState(workPages.LIST_WORKS)
    const [filteredOrders, setFilteredOrders] = useState(null)
    const [validUsersIds, setValidUsersIds] = useState([])

    useEffect(() => {
        db.ref(Constants.MAIN_NODES.USERS).once('value')
        .then(usersSnap => {
            const clientsLoaded = {}
            const employeesLoaded = {}
            if (usersSnap.exists()) {
                usersSnap.forEach(userSnap => {
                    const user = userSnap.val()
                    if (user.userType === Constants.USER_TYPES.CLIENT) {
                        clientsLoaded[user.id] = user
                    }
                    if (user.userType === Constants.USER_TYPES.EMPLOYEE) {
                        employeesLoaded[user.id] = user
                    }
                })
            }
            const validUsers = []
            if (validUsersIds.length === 0) {
                Object.keys(employeesLoaded).forEach(employeeId => {
                    if (employeesLoaded[employeeId].email.includes('@sdingenieria.com.ar')) {
                        validUsers.push(employeeId)
                    }
                })
            }
            //validUsers.push('UOGyrHJuhjMjW5wXrt54LDwVukX2')
            setValidUsersIds(validUsers)
            setEmployees(employeesLoaded)
        })
        .catch(err => {
            console.log('Error getting users: ' + JSON.stringify(err))
        })
    }, [])

    useEffect(() => {
        if (validateUser() && works === null) {
            getData()
        }
    }, [works, companyType])


    const getData = () => {
        firestore.collection(`${Constants.MAIN_NODES.WORK_ORDERS}`).get()
            .then(workDocs => {
                const worksLoaded = {}
                const worksFiltered = {}
                if (!workDocs.empty) {
                    workDocs.forEach(workDoc => {
                        const work = workDoc.data()
                        worksLoaded[work.id] = work
                        if (companyType === 'Arcasa') {
                            if (work.company === 'Arcasa' || work.company === undefined) worksFiltered[work.id] = work //TODO: remove undefined when all works have company
                        } else {
                            if (work.company === 'SD') worksFiltered[work.id] = work
                        }
                    })
                }
                db.ref(Constants.MAIN_NODES.USERS).once('value')
                    .then(usersSnap => {
                        const clientsLoaded = {}
                        const employeesLoaded = {}
                        if (usersSnap.exists()) {
                            usersSnap.forEach(userSnap => {
                                const user = userSnap.val()
                                if (user.userType === Constants.USER_TYPES.CLIENT) {
                                    clientsLoaded[user.id] = user
                                }
                                if (user.userType === Constants.USER_TYPES.EMPLOYEE) {
                                    employeesLoaded[user.id] = user
                                }
                            })
                        }
                        setWorks(worksLoaded)
                        setClients(clientsLoaded)
                        setEmployees(employeesLoaded)
                        setFilteredOrders(worksFiltered)
                    })
                    .catch(err => {
                        console.log('Error getting users: ' + JSON.stringify(err))
                    })
            })
            .catch(err => {
                console.log('Error getting works: ' + JSON.stringify(err))
            })
        firestore.collection(`${Constants.MAIN_NODES.BID_ORDERS}`).get()
            .then(bidDocs => {
                const bidsLoaded = {}
                if (!bidDocs.empty) {
                    bidDocs.forEach(bidDoc => {
                        const bid = bidDoc.data()
                        bidsLoaded[bid.id] = bid
                    })
                }
                setBids(bidsLoaded)
            })
            .catch(err => {
                console.log('Error getting bids: ' + JSON.stringify(err))
            })
        return <LoadingPage/>
    }

    const onNewWorkBack = (isNewWorkOrder, newWorkOrder) => {
        if (isNewWorkOrder && newWorkOrder) {
            const worksLoaded = cloneDeep(works)
            worksLoaded[newWorkOrder.id] = newWorkOrder
            setWorks(worksLoaded)
            // Agregar a filteredOrders si pertenece a la empresa actual
            if (newWorkOrder.company === companyType || (companyType === 'Arcasa' && newWorkOrder.company === undefined)) {
                const filteredLoaded = cloneDeep(filteredOrders)
                filteredLoaded[newWorkOrder.id] = newWorkOrder
                setFilteredOrders(filteredLoaded)
            }
            setWorkPage(workPages.LIST_WORKS)
            window.location.reload()
        } else {
            setWorkPage(workPages.LIST_WORKS)
        }
    }

    const onWorkOderDeleted = id => {
        const worksLoaded = cloneDeep(works)
        if (id && worksLoaded && worksLoaded[id]) {
            delete worksLoaded[id]
            delete filteredOrders[id]
            setWorks(worksLoaded)
        }
    }

    const onShowWorkOrder = id => {
        if(id && works && works[id]) {
            setWorkOrderIdToEdit(id)
            setWorkPage(workPages.DETAILS_WORK)
        }
    }

    const onDetailsWorkBack = (editWorkOrder, workOrderToUpdate) => {
        if (editWorkOrder && workOrderToUpdate) {
            const worksLoaded = cloneDeep(works)
            worksLoaded[workOrderToUpdate.id] = workOrderToUpdate
            setWorks(worksLoaded)
            setWorkPage(workPages.LIST_WORKS)
        } else {
            setWorkPage(workPages.LIST_WORKS)
        }
    }

    const updateWorkOrder = (workOrderToUpdate) => {
        if (workOrderToUpdate) {
            const worksLoaded = cloneDeep(works)
            worksLoaded[workOrderToUpdate.id] = workOrderToUpdate
            setWorks(worksLoaded)
            // Actualizar filteredOrders si el workOrder actualizado pertenece a la empresa actual
            if (workOrderToUpdate.company === companyType || (companyType === 'Arcasa' && workOrderToUpdate.company === undefined)) {
                const filteredLoaded = cloneDeep(filteredOrders)
                filteredLoaded[workOrderToUpdate.id] = workOrderToUpdate
                setFilteredOrders(filteredLoaded)
            } else {
                // Si cambió de empresa, eliminarlo del filtro
                const filteredLoaded = cloneDeep(filteredOrders)
                if (filteredLoaded[workOrderToUpdate.id]) {
                    delete filteredLoaded[workOrderToUpdate.id]
                    setFilteredOrders(filteredLoaded)
                }
            }
        }
    }

    const validateUser = () => {
        // if (props.user && props.user.id && validUsersIds.includes(props.user.id)) {
        //     return true
        // }
        // return false
        return true
    }

    const renderWorkPage = workPage => {
        switch (workPage) {
            case workPages.LIST_WORKS:
                return <ListWorks onNewWorkSelected={() => setWorkPage(workPages.NEW_WORK)} works={filteredOrders}
                                employees={employees} bids={bids} clients={clients} onWorkOrderDeleted={onWorkOderDeleted}
                                onShowWorkOrder={onShowWorkOrder} companyType={companyType}/>
            case workPages.DETAILS_WORK:
                return <DetailsWork workOrderToEdit={works[workOrderIdToEdit]} bids={bids} employees={employees} clients={clients} onBack={onDetailsWorkBack} onUpdateWorkOrder={updateWorkOrder}/>
            case workPages.NEW_WORK:
                return <NewWork employees={employees} clients={clients} onBack={onNewWorkBack}/>
            default:
                return <ListWorks onNewWorkSelected={() => setWorkPage(workPages.NEW_WORK)} works={filteredOrders}
                                employees={employees} bids={bids} clients={clients} onWorkOrderDeleted={onWorkOderDeleted}
                                onShowWorkOrder={onShowWorkOrder} companyType={companyType}/>
        }
    }

    return (
        <div className="worksEmployeeCont">
            {
                workPage === workPages.LIST_WORKS && validateUser() ?
                <div style={{ position: "absolute", right:"0", marginBottom: "16px" }}>
                    {companyType === 'Arcasa' ? 
                        <Image src="/icons/logo_arcasa.png" alt="Arcasa" width={100} /> : 
                        <Image src="/icons/logo_sdos.jpg" alt="SD" width={100} />
                    }
                </div>
                : null
            }
            {
                validateUser() ?
                    works !== null ?
                        renderWorkPage(workPage)
                        :
                        null
                    :
                    <h1 className='message'>No tiene permisos para acceder a esta sección</h1>
            }
        </div>
    )
}

WorksEmployee.propTypes = {}

const mapDispatchToPropsActions = dispatch => ({})

const mapStateToProps = state => ({
    user: getUser(state)
})

export default withRouter(connect(mapStateToProps, mapDispatchToPropsActions)(WorksEmployee))
